module.exports = __webpack_public_path__ + "img/blue_arrow.838a04bf.svg";